module.exports = __webpack_public_path__ + "static/assets/61fe52be6a05d9e91eba82c754fe6c05.png";